(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[827],{

/***/ 4827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Session; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(6265);
// EXTERNAL MODULE: ./node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(795);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@theme-ui/theme-provider/dist/theme-ui-theme-provider.esm.js + 5 modules
var theme_ui_theme_provider_esm = __webpack_require__(4888);
// EXTERNAL MODULE: ./src/contexts/app/app.provider.js + 2 modules
var app_provider = __webpack_require__(687);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/theme/index.js
var theme = __webpack_require__(6690);
// EXTERNAL MODULE: ./src/components/layout.js + 11 modules
var layout = __webpack_require__(5462);
// EXTERNAL MODULE: ./src/components/link.js
var components_link = __webpack_require__(8055);
// EXTERNAL MODULE: ./src/assets/patternBG.png
var patternBG = __webpack_require__(8181);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/lightgallery/react/Lightgallery.es5.js
var Lightgallery_es5 = __webpack_require__(8680);
;// CONCATENATED MODULE: ./src/components/session/gallery/gallery.js




function Gallery(props) {
    var rawImages = props.images;
    var ref = (0,react.useState)(), images = ref[0], setImages = ref[1];
    (0,react.useEffect)(function() {
        var imagesTags = [];
        for(var i = 0; i < rawImages.length; i++){
            imagesTags.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: rawImages[i].originalSource.source,
                style: {
                    marginTop: 1 + "px",
                    marginRight: 10 + "px",
                    overflow: "hidden",
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: rawImages[i].thumbnailSource.source
                })
            }, i));
        }
        setImages(imagesTags);
    }, []);
    var onInit = function() {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_ui_components_esm/* Text */.xv, {
                as: "p",
                sx: {
                    variant: "sectionHeader.subTitle",
                    color: "heading",
                    opacity: 1
                },
                children: "Images"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    lineHeight: 2 + "px",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightgallery_es5/* default */.Z, {
                    licenseKey: "513A96E2-744F44B0-810C09A0-AE2A1F4D",
                    onInit: onInit,
                    plugins: [],
                    children: images
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(4853);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(594);
// EXTERNAL MODULE: ./src/config.js
var src_config = __webpack_require__(3726);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Alert.js + 49 modules
var Alert = __webpack_require__(7905);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ProgressBar.js
var ProgressBar = __webpack_require__(1479);
// EXTERNAL MODULE: ./src/components/session/auth/authorization.module.css
var authorization_module = __webpack_require__(6664);
var authorization_module_default = /*#__PURE__*/__webpack_require__.n(authorization_module);
;// CONCATENATED MODULE: ./src/components/session/auth/authorization.js










function Authorization(props) {
    var sessionId = props.sessionId;
    var captchaRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(props.defaultAccessCode), accessCode = ref[0], setAccessCode = ref[1];
    var ref1 = (0,react.useState)(""), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var genericError = "Unknown error has occurred, please try again.";
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var captchaToken, response, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        setErrorMessage("");
                        _ctx.prev = 2;
                        e.preventDefault();
                        _ctx.next = 6;
                        return captchaRef.current.executeAsync();
                    case 6:
                        captchaToken = _ctx.sent;
                        captchaRef.current.reset();
                        _ctx.next = 10;
                        return axios/* default.post */.Z.post("".concat(src_config/* API_BASE_URL */.CT, "/sessions/viewing/authenticate"), {
                            sessionId: sessionId,
                            accessCode: accessCode,
                            captchaToken: captchaToken
                        });
                    case 10:
                        response = _ctx.sent;
                        _ctx.t0 = response.status;
                        _ctx.next = _ctx.t0 === 200 ? 14 : 16;
                        break;
                    case 14:
                        props.onAuthorization(response.data.accessToken);
                        return _ctx.abrupt("break", 18);
                    case 16:
                        setErrorMessage(genericError);
                        setLoading(false);
                    case 18:
                        _ctx.next = 25;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t1 = _ctx["catch"](2);
                        ;
                        if ((_ctx.t1 === null || _ctx.t1 === void 0 ? void 0 : (ref = _ctx.t1.response) === null || ref === void 0 ? void 0 : ref.status) === 400) {
                            setErrorMessage(_ctx.t1.response.data.errorMessage);
                        } else {
                            setErrorMessage(genericError);
                        }
                        setLoading(false);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    20
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (authorization_module_default()).child,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (authorization_module_default()).accessCodeEntry,
                    children: [
                        !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            onSubmit: handleSubmit,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "input-group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: "txt-access-code",
                                        type: "text",
                                        className: "form-control ".concat((authorization_module_default()).accessCode),
                                        placeholder: "Access Code",
                                        value: accessCode,
                                        onChange: function(e) {
                                            return setAccessCode(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "input-group-btn",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            id: "btn-validate",
                                            className: "btn btn-success ".concat((authorization_module_default()).goButton),
                                            type: "submit",
                                            children: "Go!"
                                        })
                                    })
                                ]
                            })
                        }),
                        errorMessage != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                    variant: "danger",
                                    children: errorMessage
                                })
                            })
                        }),
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar/* default */.Z, {
                                        variant: "success",
                                        animated: true,
                                        now: 100
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                size: "invisible",
                sitekey: src_config/* RECAPTCHA_KEY */.SN,
                ref: captchaRef
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-azure-mp/dist/index.es.js
var index_es = __webpack_require__(4232);
;// CONCATENATED MODULE: ./src/components/session/video/video.js


function Video(props) {
    var videoDownloadUrl = props.videoDownloadUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* AzureMP */.L, {
        skin: "amp-flush",
        options: {
            autoplay: true
        },
        src: [
            {
                src: videoDownloadUrl,
                type: "video/mp4"
            }
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/js-file-download/file-download.js
var file_download = __webpack_require__(5823);
var file_download_default = /*#__PURE__*/__webpack_require__.n(file_download);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 3 modules
var Card = __webpack_require__(7525);
// EXTERNAL MODULE: ./node_modules/lightgallery/plugins/video/lg-video.es5.js
var lg_video_es5 = __webpack_require__(2523);
;// CONCATENATED MODULE: ./src/assets/video_thumbnail.png
/* harmony default export */ var video_thumbnail = ({"src":"/_next/static/media/video_thumbnail.5c7ddc61.png","height":110,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAtklEQVR42mOQtyuTsy1l0M5n0Mln0MoHMoBcoCCDLJiKSusKT+mMy+oFMhTsy4CCDAyyOWX1s6bP3dA3ZVV181wgA8hlkM1mYBDNauxY4B7etHDZjo7+Za6hDY2dC4GCDAwiWQ3tC9p6l8xbsq2kdhZQU1PXQgZBoIRMdmndzMPHL63fcnjh8p07952qaprDIJ4NslzRvsw1rNE3piUwvs0rqhnqTiAlC6SMixiMChkMCoEkxLkAgjlJmoTfZnAAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./node_modules/lightgallery/css/lightgallery.css
var lightgallery = __webpack_require__(5852);
// EXTERNAL MODULE: ./node_modules/lightgallery/css/lg-zoom.css
var lg_zoom = __webpack_require__(1625);
// EXTERNAL MODULE: ./node_modules/lightgallery/css/lg-video.css
var lg_video = __webpack_require__(5202);
// EXTERNAL MODULE: ./node_modules/lightgallery/css/lg-thumbnail.css
var lg_thumbnail = __webpack_require__(7884);
;// CONCATENATED MODULE: ./src/components/session/gallery/video-clip-gallery.js










function VideoClipGallery(props) {
    var rawClips = props.videoClips;
    var thumbnails = props.thumbnails;
    var ref = (0,react.useState)(), clips = ref[0], setClips = ref[1];
    (0,react.useEffect)(function() {
        var clipTags = [];
        for(var i = 0; i < rawClips.length; i++){
            var thumbnailSrc = video_thumbnail.src;
            if (thumbnails.length > 0) {
                thumbnailSrc = thumbnails[0].thumbnailSource.source;
                if (thumbnails.length > i) {
                    thumbnailSrc = thumbnails[i].thumbnailSource.source;
                }
            }
            var src = '{"source": [{"src":"' + rawClips[i].clipContent.source + '", "type":"video/mp4"}], "attributes": {"preload": false, "controls": true}}';
            clipTags.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                "data-video": src,
                class: "overlay-play-button",
                style: {
                    cursor: "pointer",
                    marginTop: 1 + "px",
                    marginRight: 10 + "px",
                    overflow: "hidden",
                    display: "inline-block"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: thumbnailSrc,
                        style: {
                            filter: "blur(2px)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        class: "overlay-play-button__overlay",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            class: "overlay-play-button__play",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "triangle triangle--r triangle--sm"
                            })
                        })
                    })
                ]
            }, i));
        }
        setClips(clipTags);
    }, []);
    var onInit = function() {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_ui_components_esm/* Text */.xv, {
                as: "p",
                sx: {
                    variant: "sectionHeader.subTitle",
                    color: "heading",
                    opacity: 1
                },
                children: "Video Clips"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    lineHeight: 2 + "px",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightgallery_es5/* default */.Z, {
                    licenseKey: "513A96E2-744F44B0-810C09A0-AE2A1F4D",
                    onInit: onInit,
                    download: false,
                    plugins: [
                        lg_video_es5/* default */.Z
                    ],
                    children: clips
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/session/session.js
/** @jsxImportSource theme-ui */ 






















function Session(param) {
    var sessionId = param.sessionId, defaultAccessCode = param.defaultAccessCode;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), authenticated = ref4[0], setAuthenticated = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var ref6 = (0,react.useState)(""), loadingLabel = ref6[0], setLoadingLabel = ref6[1];
    var ref7 = (0,react.useState)(""), errorMessage = ref7[0], setErrorMessage = ref7[1];
    var ref8 = (0,react.useState)(null), accessToken = ref8[0], setAccessToken = ref8[1];
    var ref9 = (0,react.useState)(null), sessionContent = ref9[0], setSessionContent = ref9[1];
    var genericError = "Error has occurred, please try again.";
    (0,react.useEffect)(function() {
        function fetchSessionContent() {
            return _fetchSessionContent.apply(this, arguments);
        }
        function _fetchSessionContent() {
            _fetchSessionContent = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var headersConfig, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(accessToken == null)) {
                                _ctx.next = 4;
                                break;
                            }
                            {
                                setAuthenticated(false);
                            }
                            _ctx.next = 28;
                            break;
                        case 4:
                            _ctx.prev = 4;
                            setLoading(true);
                            headersConfig = {
                                headers: {
                                    "Authorization": "Bearer ".concat(accessToken)
                                }
                            };
                            _ctx.next = 9;
                            return axios/* default.get */.Z.get("".concat(src_config/* API_BASE_URL */.CT, "/sessions/viewing/content"), headersConfig);
                        case 9:
                            response = _ctx.sent;
                            if (!(response.status == 200)) {
                                _ctx.next = 14;
                                break;
                            }
                            {
                                setSessionContent(response.data);
                                setAuthenticated(true);
                            }
                            _ctx.next = 19;
                            break;
                        case 14:
                            if (!(response.status == 401)) {
                                _ctx.next = 18;
                                break;
                            }
                            {
                                setAccessToken(null);
                            }
                            _ctx.next = 19;
                            break;
                        case 18:
                            throw "session content request failure";
                        case 19:
                            _ctx.next = 25;
                            break;
                        case 21:
                            _ctx.prev = 21;
                            _ctx.t0 = _ctx["catch"](4);
                            setErrorMessage(genericError);
                            throw _ctx.t0;
                        case 25:
                            _ctx.prev = 25;
                            setLoading(false);
                            return _ctx.finish(25);
                        case 28:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        21,
                        25,
                        28
                    ]
                ]);
            }));
            return _fetchSessionContent.apply(this, arguments);
        }
        fetchSessionContent();
    }, [
        accessToken
    ]);
    function download() {
        return _download.apply(this, arguments);
    }
    function _download() {
        _download = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var config, response, fileNameId, contentHeader, suggestedFileName;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        setLoadingLabel("Downloading, please wait...");
                        config = {
                            responseType: "blob",
                            headers: {
                                "Authorization": "Bearer ".concat(accessToken)
                            }
                        };
                        _ctx.next = 6;
                        return axios/* default.get */.Z.get("".concat(src_config/* API_BASE_URL */.CT, "/sessions/download/content/images"), config);
                    case 6:
                        response = _ctx.sent;
                        fileNameId = "filename=";
                        contentHeader = response.headers["content-disposition"];
                        suggestedFileName = contentHeader.substring(contentHeader.indexOf(fileNameId) + fileNameId.length);
                        file_download_default()(response.data, suggestedFileName);
                    case 11:
                        _ctx.prev = 11;
                        setLoading(false);
                        setLoadingLabel("");
                        return _ctx.finish(11);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    ,
                    11,
                    15
                ]
            ]);
        }));
        return _download.apply(this, arguments);
    }
    function downloadClips() {
        return _downloadClips.apply(this, arguments);
    }
    function _downloadClips() {
        _downloadClips = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var config, response, fileNameId, contentHeader, suggestedFileName;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        setLoadingLabel("Downloading, please wait...");
                        config = {
                            responseType: "blob",
                            headers: {
                                "Authorization": "Bearer ".concat(accessToken)
                            }
                        };
                        _ctx.next = 6;
                        return axios/* default.get */.Z.get("".concat(src_config/* API_BASE_URL */.CT, "/sessions/download/content/videoclips"), config);
                    case 6:
                        response = _ctx.sent;
                        fileNameId = "filename=";
                        contentHeader = response.headers["content-disposition"];
                        suggestedFileName = contentHeader.substring(contentHeader.indexOf(fileNameId) + fileNameId.length);
                        file_download_default()(response.data, suggestedFileName);
                    case 11:
                        _ctx.prev = 11;
                        setLoading(false);
                        setLoadingLabel("");
                        return _ctx.finish(11);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    ,
                    11,
                    15
                ]
            ]);
        }));
        return _downloadClips.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_theme_provider_esm/* ThemeProvider */.f, {
                theme: theme/* default */.Z,
                children: [
                    !authenticated && sessionId && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(layout/* default */.Z, {
                        navHidden: "true",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("section", {
                            sx: styles.auth,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Authorization, {
                                sessionId: sessionId,
                                defaultAccessCode: defaultAccessCode,
                                onAuthorization: function(accessToken) {
                                    setAccessToken(accessToken);
                                }
                            })
                        })
                    }),
                    authenticated && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(app_provider/* StickyProvider */.nK, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(layout/* default */.Z, {
                            navHidden: "true",
                            title: sessionContent.name,
                            fixedFooter: "true",
                            children: [
                                sessionContent != null && errorMessage === "" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("section", {
                                            sx: styles.video,
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                                                children: [
                                                    sessionContent.type == "VideoAndImages" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                                                        children: [
                                                            sessionContent.videoState == "Viewable" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Video, {
                                                                videoDownloadUrl: sessionContent.videoDownloadUrl
                                                            }),
                                                            sessionContent.videoState != "Viewable" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Card/* default */.Z, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Card/* default.Body */.Z.Body, {
                                                                        style: {
                                                                            minHeight: "15rem"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Card/* default.Title */.Z.Title, {
                                                                                children: "The video is not ready to view!"
                                                                            }),
                                                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Card/* default.Text */.Z.Text, {
                                                                                children: "Please check back later."
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Card/* default.Footer */.Z.Footer, {
                                                                        children: [
                                                                            "Video State: ",
                                                                            sessionContent.videoState
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
                                                        style: {
                                                            minHeight: "3rem"
                                                        },
                                                        children: [
                                                            !loading && ((ref = sessionContent.images) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                                                                children: sessionId != src_config/* DEMO_SESSION_ID */.d6 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                                                    sx: styles.download,
                                                                    variant: "whiteButton",
                                                                    "aria-label": "Download",
                                                                    onClick: download,
                                                                    children: "Download Images"
                                                                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                                                    sx: styles.download,
                                                                    variant: "grayButton",
                                                                    "aria-label": "Download (Disabled for Demo)",
                                                                    children: "Download Images (Disabled for Demo)"
                                                                })
                                                            }),
                                                            !loading && ((ref1 = sessionContent.videoClips) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                                                sx: styles.download,
                                                                variant: "whiteButton",
                                                                "aria-label": "Download",
                                                                onClick: downloadClips,
                                                                children: "Download Video Clips"
                                                            }),
                                                            sessionContent.type == "VideoAndImages" && sessionContent.videoState == "Viewable" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                                                                children: sessionId != src_config/* DEMO_SESSION_ID */.d6 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(components_link/* Link */.r, {
                                                                    path: sessionContent.videoDownloadUrl,
                                                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                                                        sx: styles.download,
                                                                        variant: "whiteButton",
                                                                        "aria-label": "Download Video",
                                                                        children: "Download Video"
                                                                    })
                                                                }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                                                                    disabled: true,
                                                                    sx: styles.download,
                                                                    variant: "grayButton",
                                                                    "aria-label": "Download Video (Disabled for Demo)",
                                                                    children: "Download Video (Disabled for Demo)"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                                                sx: styles.clearfix
                                                            }),
                                                            loading && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProgressBar/* default */.Z, {
                                                                className: "mb-2 mt-2",
                                                                variant: "success",
                                                                animated: true,
                                                                now: 100,
                                                                label: loadingLabel
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("section", {
                                            sx: styles.images,
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                                    children: ((ref2 = sessionContent.videoClips) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(VideoClipGallery, {
                                                        videoClips: sessionContent.videoClips,
                                                        thumbnails: sessionContent.images
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("section", {
                                            sx: styles.images,
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                                    children: ((ref3 = sessionContent.images) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Gallery, {
                                                        images: sessionContent.images
                                                    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("p", {
                                                        children: "Images will display here after the ultrasound facility uploads the images from the session."
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                errorMessage != "" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("section", {
                                    sx: styles.video,
                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
                                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Container/* default */.Z, {
                                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Row/* default */.Z, {
                                                    className: "mt-3",
                                                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Alert/* default */.Z, {
                                                        variant: "danger",
                                                        children: errorMessage
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var styles = {
    download: {
        margin: 2,
        float: "right"
    },
    clearfix: {
        clear: "both"
    },
    auth: {
        paddingTop: 100,
        height: "100vh",
        backgroundColor: "primary",
        backgroundImage: "url(".concat(patternBG/* default.src */.Z.src, ")"),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        position: "relative"
    },
    video: {
        backgroundColor: "primary",
        backgroundImage: "url(".concat(patternBG/* default.src */.Z.src, ")"),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        position: "relative",
        paddingTop: 100
    },
    images: {
        marginTop: 25,
        mb: 75
    }
};


/***/ }),

/***/ 6664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accessCodeEntry":"authorization_accessCodeEntry__m6IWi","goButton":"authorization_goButton__H47FT","accessCode":"authorization_accessCode__W4RV3","parent":"authorization_parent__TwDx4","child":"authorization_child__b2Juf"};

/***/ })

}]);